(() => {
  "use strict";


  if (window.__SECURITY_RUNNING__) return;
  window.__SECURITY_RUNNING__ = true;

  const ROOT_ID = "SECURITY_ROOT";
  const MAX_REPAIR_MS = 7000;

  const ED = !!(window.Shopify && Shopify.designMode);

  function qs(sel, root) {
    try { return (root || document).querySelector(sel); } catch { return null; }
  }
  function qsa(sel, root) {
    try { return Array.from((root || document).querySelectorAll(sel)); } catch { return []; }
  }

  function dedupeRoots() {
    const all = qsa(`#${ROOT_ID}`);
    if (all.length <= 1) return all[0] || null;

    const keep = all[0];
    for (let i = 1; i < all.length; i++) {
      try { all[i].remove(); } catch {}
    }
    return keep;
  }

  function findButtonsAnchor() {

    const shopPay = qs(".shopify-payment-button");
    if (shopPay) return shopPay;

    const btnWrap =
      qs(".product-form__buttons") ||
      qs("product-form .product-form__buttons") ||
      qs("form[action*='/cart/add'] .product-form__buttons");
    if (btnWrap) return btnWrap;

    const btn =
      qs("form[action*='/cart/add'] button[type='submit']") ||
      qs("button[name='add']") ||
      qs(".product-form__submit");

    return btn ? (btn.closest("form[action*='/cart/add']") || btn.parentElement) : null;
  }

  function ensurePlaced() {
    const root = dedupeRoots();
    if (!root) return;

    const anchor = findButtonsAnchor();
    if (!anchor) return;

    const next = anchor.nextElementSibling;
    if (next && next.id === ROOT_ID) return;

    try { anchor.insertAdjacentElement("afterend", root); } catch {}
  }

  async function ensurePlacedWithRetry() {
    for (let i = 0; i < 30; i++) { // ~3s
      ensurePlaced();
      const root = qs(`#${ROOT_ID}`);
      const anchor = findButtonsAnchor();
      if (root && anchor && anchor.nextElementSibling === root) return true;
      await new Promise(r => setTimeout(r, 100));
    }
    return false;
  }

  function boot() {

    ensurePlaced();
    ensurePlacedWithRetry();

    if (ED) return;

    const start = Date.now();

    const mo = new MutationObserver(() => {
      ensurePlaced();
      if (Date.now() - start > MAX_REPAIR_MS) {
        try { mo.disconnect(); } catch {}
      }
    });

    try {
      mo.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => { try { mo.disconnect(); } catch {} }, MAX_REPAIR_MS);
    } catch {}

    setTimeout(ensurePlaced, 120);
    setTimeout(ensurePlaced, 420);
    setTimeout(ensurePlaced, 900);

    addEventListener("resize", ensurePlaced, { passive: true });
    addEventListener("pageshow", ensurePlaced, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
  